import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const PurchaseOrdersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 20V7.1L2.05 2.85L3.85 2L6.2 7.05H17.8L20.15 2L21.95 2.85L20 7.1V20H4ZM10 13H14C14.2833 13 14.5208 12.9042 14.7125 12.7125C14.9042 12.5208 15 12.2833 15 12C15 11.7167 14.9042 11.4792 14.7125 11.2875C14.5208 11.0958 14.2833 11 14 11H10C9.71667 11 9.47917 11.0958 9.2875 11.2875C9.09583 11.4792 9 11.7167 9 12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13ZM6 18H18V9.05H6V18Z" />
    </SvgIcon>
  );
};

export default PurchaseOrdersIcon;
